type apiParams = string | number;

export const __API = {
  test: '',
  bankAccount: {
    getAll: 'Admin/BankAccount/GetAll',
    create: 'Admin/BankAccount/CreateByAdmin',
    delete: 'Admin/BankAccount/Delete',
  },
  balancerTransaction: {
    getAll: 'admin/balancertransaction',
    getById: 'admin/balancertransaction/getbyid',
    add: 'admin/balancertransaction/add',
    update: 'admin/balancertransaction/update',
    delete: 'admin/balancertransaction/delete',
    lossAndProfitReport: 'admin/balancertransaction/lossandprofitreport',
  },
  campaigns: {
    getAll: 'Admin/Campaigns',
    getDetail: 'Admin/Campaigns/CampaignDetail',
  },
  content: {
    getAllTopics: 'Admin/Content/AllTopics',
    getTopicById: 'Admin/Content/TopicById',
    editTopic: 'Admmin/Content/EditTopic',
    addTopic: 'Admin/Content/AddTopic',
    getAllCategories: 'Admin/Content/AllCategories',
    getCategoryById: 'Admin/Content/CategoryById',
    editCategory: 'Admin/Content/EditCategory',
    addCategory: 'Admin/Content/AddCategory',
    getAllContent: 'Admin/Content/AllContents',
    getContentById: 'Admin/Content/ContentById',
    editContent: 'Admin/Content/EditContent',
    addContent: 'Admin/Content/AddContent',
  },
  fiat: {
    getAll: 'Admin/Fiat/GetAll',
    edit: 'Admin/Fiat/Edit',
  },
  kucoin: {
    history: 'Admin/Kucoin/History',
  },
  bankAccountStatement: {
    getAll: 'Admin/BankAccountStatement',
    create: 'Admin/BankAccountStatement/Create',
    confirmAndPayout: 'Admin/BankAccountStatement/ConfirmAndPayout',
  },
  banks: {
    getAll: 'Bank/All',
  },
  auditLog: {
    getAll: 'AuditLog/GetAll',
    getById: 'AuditLog/GetById',
  },
  siteSettings: {
    offlineDepositSetting: 'Admin/SiteSettings/OfflineDepositSetting',
    changeOfflineDepositSetting: 'Admin/SiteSettings/ChangeOfflineDepositSettings',
    cardToCardSettings: 'Admin/SiteSettings/CardToCardSettings',
    updateCardToCardSettings: 'Admin/SiteSettings/UpdateCardToCardSettings',
    changeCardToCardActivationSettings: 'Admin/SiteSettings/ChangeCardToCardActivationSettings',
  },
  enum: {
    getMarketTypes: 'Enum/MarketTypes',
    getOrderSides: 'Enum/OrderSides',
    getOrderState: 'Enum/OrderState',
    getOrderSources: 'Enum/OrderSources',
    getOrderType: 'Enum/OrderType',
    getTransactionStates: 'Enum/TransactionStates',
    getTransactionTypes: 'Enum/TransactionTypes',
    getTransactionSourceTypes: 'Enum/TransactionSourceTypes',
    getTransactionMarketType: 'Enum/TransactionMarketType',
    getPlatforms: 'Enum/Platforms',
    getDepositCurrencyType: 'Enum/DepositCurrencyType',
    bankAccountStatementChargeStatus: 'Enum/BankAccountStatementState',
    bankAccountStatementType: 'Enum/BankAccountStatementType',
    cardToCardService: 'Enum/CardToCardService',
    utopiaFilter: 'Enum/UtopiaFilter',
    referralInfoSortDirection: 'Enum/ReferralInfoSortDirection'
  },
  financialSettings: {
    getFinancialSettingsById: 'Admin/FinancialSettings/Get',
    editFinancialSettings: 'Admin/FinancialSettings/Edit',
    removeFinancialSetting: 'Admin/FinancialSettings/remove',
  },
  market: {
    networks: 'Market/Networks/Deposit',
    getAllMarketV2: 'Admin/Market/Get-All',
    edit: 'Admin/Market/Edit',
  },
  marketContent: {
    getMarketContentBySymbolAdmin: 'MarketContent/GetBySymbol',
    getMarketCommentsBySymbolAdmin: 'Admin/MarketContent/GetMarketCommentsBySymbol',
    getMarketFaqsBySymbolAdmin: 'Admin/MarketContent/GetMarketFaqsBySymbol',
    updateMarketContent: 'Admin/MarketContent/UpdateMarketContent',
    updateFaqs: 'Admin/MarketContent/UpdateMarketContentFaqs',
    updateComments: 'Admin/MarketContent/UpdateMarketContentComments',
  },
  referral: {
    getAllReferralInfos: 'Admin/Referral/GetAllReferalInfos',
    getAllReferralWithdrawals: 'Admin/Referral/GetAllReferralWithdrawals',
    getReferralWithdrawalStates: 'Enum/ReferralWidthrawalState',
    getAllReferralActions: 'Admin/Referral/GetAllRefferalActions',
    confirmWithdrawalReferral: 'Admin/Referral/ConfirmWithdrawalReferral',
  },
  orders: {
    getAll: 'Admin/OrderTransaction/GetAll',
    orderTransactionTypes: 'Enum/OrderTransactionTypes',
    orderTransactionState: 'Enum/OrderTransactionStates',
    orderStates: 'Enum/OrderState',
    edit: 'Order/edit',
    searchByTrackingCode: 'Admin/OrderTransaction/SearchWithTrackingCodeByAdmin',
    searchWithKeyword: 'Admin/OrderTransaction/SearchWithKeywordByAdmin',
    confirmAndPayout: 'Admin/OrderTransaction/ConfirmAndPayoutOrder',
    getGateWaysTransactions: 'Admin/OrderTransaction/GetGateWaysTransactions',
    getGateWaysTransaction: 'Admin/OrderTransaction/GetGateWaysTransaction',
    trackVoucher: 'Admin/OrderTransaction/TrackVoucherByAdmin',
    transactionStates: 'Enum/TransactionStates',
    transactionTypes: 'Enum/TransactionTypes',
    editOrderTransaction: 'Admin/OrderTransaction/EditOrderTransaction',
  },
  oldTxIds: {
    all: 'Admin/OldTxIds',
    create: 'Admin/OldTxIds'
  },
  order: {
    getAll: 'Admin/Order/GetAll',
    getCount: 'Admin/Order/GetPaginated',
    getDetails: 'Admin/Order',
  },
  transaction: {
    getAll: 'Admin/Transaction/GetAll',
    getCount: 'Admin/Transaction/GetPaginated',
    getDetails: 'Admin/Transaction',
    edit: 'Admin/Transaction/Edit',
  },
  survey: {
    manualValidationStates: 'enum/validationStates',
    validationEntities: 'enum/validationEntities',
    authMediaSurvey: 'admin/manualValidation/list',
    getById: 'admin/manualValidation/details',
    update: 'authMediaSurvey/UpdateState',
    accept: 'Admin/ManualValidation/AcceptUploadedSelife',
    reject: 'Admin/ManualValidation/RejectUploadedSelife',
  },
  voucher: {
    trackVoucher: 'Admin/Voucher/TrackVoucher',
    utopiaVouchers: 'Admin/Voucher/GetAllUtopiaVouchers',
    depositUtopiaByAdmin: 'Admin/Voucher/DepositUtopiaByAdmin',
  },
  dashboard: {
    getSumBuyAndSellCommissions: 'Admin/Dashboard/SumBuyAndSellCommissions',
    getUploadedDocumentsChart: 'Admin/Dashboard/DocumentUploadedCount',
    getRegisteredUsersCount: 'Admin/Dashboard/RegisteredUsersCount',
    getAuthenticatedUsersCount: 'Admin/Dashboard/AuthenticatedUsersCount',
    getBalances: 'Admin/Dashboard/Balances',
    getFirstBuys: 'Admin/Dashboard/FirstBuyOrderCounts',
    getUSDTWithdrawalCount: 'Admin/Dashboard/CountWithdrawalUsdtChart',
    getCryptoSumBuyAndSell: 'Admin/Dashboard/SumBuyAndSellCrypto',
    getPMSumBuyAndSell: 'Admin/Dashboard/SumBuyAndSellUUSDQ',
    getSumBuyAndSell: 'Admin/Dashboard/SumBuyAndSell',
    getCryptoCountBuyAndSell: 'Admin/Dashboard/CryptoCountBuyAndSell',
    getPMCountBuyAndSell: 'Admin/Dashboard/UVoucherCountBuyAndSell',
    getCountBuyAndSell: 'Admin/Dashboard/CountBuyAndSell',
  },
  users: {
    login: 'user/login',
    exist: 'user/exist',
    token: 'User/Token',
    confirmPhoneNumber: 'User/ConfirmPhoneNumber',
    setPassWord: 'User/SetPassWord',
    sendSmsCode: 'User/Login/SendCode',
    confirmCode: 'User/Login/VerifyCode',
    profile: 'User/Profile/Current',
    getAll: 'Admin/User/All',
    getById: 'Admin/User/Detail',
    getByPhoneNumber: 'Admin/User/GetByPhoneNumber',
    update: 'Admin/User/Edit-User',
    levels: 'Level/Levels',
    // verify2Step: "User/Login/VerifyTwoStepSignIn",
    getAllCategories: 'Enum/UserCategory',
  },
  userSavedWallets: {
    getAll: 'Admin/UserSavedWallet/GetAll',
    getById: 'UserSavedWallet/GetById',
    add: 'Admin/UserSavedWallet/Add',
    edit: 'Admin/UserSavedWallet/Edit',
    remove: 'Admin/UserSavedWallet/Remove',
  },
  wallet: {
    userWallet: (id: string) => `Admin/Wallet/userWallet/${id}`,
    updateWallet: 'Admin/Wallet/UpdateWallet',
    syncWallet: 'Admin/Wallet/SyncWallet'
  },
  userSavedIBans: {
    getAll: 'Admin/UserSavedIBan/GetAll',
    getById: 'UserSavedIBan/GetById',
    add: 'Admin/UserSavedIBan/Add',
    edit: 'Admin/UserSavedIBan/Edit',
    remove: 'Admin/UserSavedIBan/Remove',
  },
  roles: {
    getAll: 'Admin/Role/get-all',
    permissions: 'Admin/Role/get-all-permissions',
    create: 'Admin/Role/Create',
    edit: 'Admin/Role/Edit',
    getById: 'Admin/Role',
    menuItems: 'Admin/Role/get-all-menuitems',
    getMineMenuItems: 'Admin/Role/get-mine-menuitems',
  },
  general: {
    verifyCode: 'General/Login/VerifyCodeOrPw',
    verify2fa: 'General/verify-2fa',
  },
  perfectMoney: {
    active: 'Admin/PerfectMoney/ActiveVoucher',
    create: 'Admin/PerfectMoney/CreateVoucher',
    getAll: 'Admin/PerfectMoney/AllVouchers',
  },
  popUp: {
    getAll: 'Admin/PopUp/GetAllPopUps',
    add: 'Admin/PopUp/Add',
    edit: 'Admin/PopUp/Edit',
    getAllActives: 'PopUp/GetActivePopUps',
    getById: 'Admin/PopUp/GetPopUpById',
    delete: 'Admin/PopUp/Delete',
  },
};
